import { render, staticRenderFns } from "./search-components.vue?vue&type=template&id=46059d9b&scoped=true&"
import script from "./search-components.vue?vue&type=script&lang=js&"
export * from "./search-components.vue?vue&type=script&lang=js&"
import style0 from "./search-components.vue?vue&type=style&index=0&id=46059d9b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46059d9b",
  null
  
)

export default component.exports